import Loading from 'components/FullScreenLoading';
import ModalForm from 'components/ModalForm';
import MainCard from 'components/StudentStatusCards/MainCard';
import StudentCard from 'components/StudentStatusCards/StudentCard';
import Surveys from 'components/Surveys';
import {ISurveyData} from 'components/Surveys/Surveys';
import {StudentContext} from 'context/Student.context';
import {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import SERVICES from 'services';
import './Home.less';

interface GroupData {
	number: string;
	groupTypeName: string;
	subjectName: string;
	subjectTypeName: string;
}

const GroupCard = ({data}: {data: GroupData}) => {
	return (
		<div className="GroupCard">
			<div className="title"> խումբ {data.number}</div>
			<div className="description">
				<div className="info">
					<div id="about">Խմբի տեսակ՝</div>
					<div id="about-info">{data.groupTypeName}</div>
				</div>
				<div className="info">
					<div id="about">Առարկա՝</div>
					<div id="about-info">{data?.subjectName}</div>
				</div>
				<div className="info">
					<div id="about">Առարկայի տեսակ՝</div>
					<div id="about-info">{data?.subjectTypeName}</div>
				</div>
			</div>
		</div>
	);
};

const Home = () => {
	const [groups, setGroups] = useState<GroupData[]>([]);
	const {state} = useContext(StudentContext);

	useEffect(() => {
		if (state.groupIDs.length) {
			setGroups([]);
			state.groupIDs.forEach(id => {
				const params = {
					id
				};
				SERVICES.USER.getStudentGroups(params).then((res: any) => {
					setGroups(prev => [...prev, res.data]);
				});
			});
		}
	}, [state.groupIDs]);

	return (
		<div className="container student-main">
			<div className="student-card-wrapper">
				<StudentCard />
				<MainCard showExternalInfo={false} />
			</div>
			<div className="groups-wrapper">
				{groups.length ? (
					groups.map((data, idx) => <GroupCard key={idx} data={data} />)
				) : (
					<div
						style={{
							width: '100%',
							height: '100%',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						Դուք կցված չեք ոչ մի խմբի
					</div>
				)}
			</div>
			<Surveys />
		</div>
	);
};

export default Home;
